<template>
  <v-main class="main-container">
    <div class="flex-fill">
      <slot></slot>
    </div>
  </v-main>
</template>
